import { css, excludeProps, mixins, styled } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'

export interface SpotAssetProps {
  isBackgroundVideo?: boolean
  bgColor: string
}

export const SpotAsset = styled(excludeProps(Asset, 'isBackgroundVideo'))<SpotAssetProps>`
  background-color: ${({ bgColor }: SpotAssetProps) => bgColor};
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ isBackgroundVideo }: SpotAssetProps) =>
    isBackgroundVideo &&
    css`
      & > img {
        display: none;
        ${mixins.margin(0, 'auto')}
      }

      & button {
        pointer-events: all;
      }
    `}
`
